import React, { useEffect, useState } from 'react';
import { TablePagination } from '@mui/material'; // Only importing TablePagination from MUI
import LoaderComponent from '../../components/LoaderComponent/LoaderComponent';
import { getStallBookingMasters } from '../../services/apiController';

const ApplyStallList = () => {
    const [loading, setLoading] = useState(false);
    const [stallList, setStallList] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Default rows per page
    const [currentPage, setCurrentPage] = useState(1); // Default current page
    const [maxRows, setMaxRows] = useState(0); // Total number of rows
    const [gotoPage, setGotoPage] = useState(1); // Page input for jump
    const [totalPages, setTotalPages] = useState(1); // Total pages calculation
    const [searchQuery, setSearchQuery] = useState(''); // For search query
    const [sortOrder, setSortOrder] = useState({ column: '', order: 'asc' }); // For sorting state

    const [columnCount, setColumnCount] = useState(1);

    useEffect(() => {
        const thCount = document.querySelectorAll('thead th').length;
        setColumnCount(thCount || 1);
    }, []);

    useEffect(() => {
        setLoading(true);
        getStallBookingMasters({}).then((response) => {
            if (response) {
                setStallList(response);
                setMaxRows(response.length); // Set total rows from response
                setTotalPages(Math.ceil(response.length / rowsPerPage)); // Calculate total pages
            } else {
                // Handle error scenario
            }
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            // Handle API error
        });
    }, [rowsPerPage, currentPage]); // Re-run the effect when rowsPerPage or currentPage changes

    // Handle page change
    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage + 1); // MUI TablePagination uses 0-based index
    };

    // Handle rows per page change
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setCurrentPage(1); // Reset to page 1 when rows per page changes
    };

    // Handle page input change
    const handleGotoPageChange = (event) => {
        setGotoPage(event.target.value);
    };

    // Handle the submit (Enter key press) for "Go to page"
    const handleSubmitGotoPage = (event) => {
        if (event.key === 'Enter') {
            const pageNumber = Math.max(1, Math.min(totalPages, parseInt(gotoPage, 10))); // Ensure valid page
            setCurrentPage(pageNumber);
        }
    };

    // Handle search query change
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Filtered and sorted stallList
    const SEARCH_FIELDS = [
        'EventName',
        'TenantName',
        'TenantBrandName',
        'TenantEmail',
        'TenantContactNo',
        'SocialMediaLink',
        'CategoryName',
        'IsExecutedBefore',
        'SpecialRequirement'
    ];

    const filteredStalls = stallList?.filter((stall) =>
        SEARCH_FIELDS.some((field) =>
            stall[field]
                ?.toString()
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
    );

    // Sorting function
    const handleSort = (column) => {
        const newOrder = sortOrder.order === 'asc' ? 'desc' : 'asc';
        setSortOrder({
            column: column,
            order: newOrder,
        });
    };

    const sortedStalls = filteredStalls.sort((a, b) => {
        if (!sortOrder.column) return 0;

        const aValue = a[sortOrder.column];
        const bValue = b[sortOrder.column];

        if (aValue < bValue) return sortOrder.order === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortOrder.order === 'asc' ? 1 : -1;
        return 0;
    });

    return (
        loading ? <LoaderComponent />
            : <React.Fragment>
                <div style={{ padding: '10px 20px 50px', overflowX: 'auto' }}>
                    <div className='table-heading-search' style={{ marginBottom: '10px', }}>
                        <h2 className='dialog-heading' style={{ marginBlockEnd: '0px' }}>Applied for Stalls</h2>

                        {/* Search Input */}
                        <div>
                            Search: <input type="text" value={searchQuery} onChange={handleSearchChange} style={{ padding: '5px', width: '200px', border: '1px solid #ccc', borderRadius: '4px', }} />
                        </div>
                    </div>

                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th className='tableHeaderStyle' onClick={() => handleSort('EventName')}>Event Name</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('TenantName')}>Name</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('TenantBrandName')}>Brand Name</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('TenantEmail')}>E-Mail</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('TenantContactNo')}>Mobile No</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('SocialMediaLink')}>Website</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('CategoryName')}>Category</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('IsExecutedBefore')}>Executed Before</th>
                                <th className='tableHeaderStyle' onClick={() => handleSort('SpecialRequirement')}>Comments</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!sortedStalls.length
                                ? <tr>
                                    <td colSpan={columnCount} style={{ textAlign: 'center', padding: '10px', fontSize: '16px' }}>
                                        No Record Found ☹️
                                    </td>
                                </tr>
                                : sortedStalls.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
                                    .map((stall, index) => (
                                        <tr key={index} style={{ ...tableRowStyle, backgroundColor: index % 2 === 1 ? '#ececec' : '#FFFFFF' }}>
                                            <td className='tableCellStyle'>{stall.EventName}</td>
                                            <td className='tableCellStyle'>{stall.TenantName}</td>
                                            <td className='tableCellStyle'>{stall.TenantBrandName}</td>
                                            <td className='tableCellStyle'>{stall.TenantEmail}</td>
                                            <td className='tableCellStyle'>{stall.TenantContactNo}</td>
                                            <td className='tableCellStyle'><a href={stall.SocialMediaLink} target="_blank">{stall.SocialMediaLink}</a></td>
                                            <td className='tableCellStyle'>{stall.CategoryName}</td>
                                            <td className='tableCellStyle'>{stall.IsExecutedBefore ? "YES" : "NO"}</td>
                                            <td className='tableCellStyle'>{stall.SpecialRequirement}</td>
                                        </tr>
                                    ))}
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '10px' }}>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100, 200, 500, 1000]}
                            component="div"
                            count={maxRows}
                            rowsPerPage={rowsPerPage}
                            page={currentPage - 1} // MUI TablePagination uses 0-based index
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            id="page-box"
                        />
                        <div style={{ fontSize: '13px', marginLeft: '10px' }}>
                            Page: <input style={{ width: '50px', border: '1px solid #ccc', borderRadius: '5px', padding: '4px' }} type="number" value={gotoPage} disabled={totalPages <= 1} onChange={handleGotoPageChange} onKeyDown={handleSubmitGotoPage} /> Of {totalPages}
                        </div>
                    </div>
                </div>
            </React.Fragment>
    );
};

const tableRowStyle = {
    borderBottom: '1px solid #eee',
};

export default ApplyStallList;
